export default __webpack_public_path__ + "static/media/traveler.771751d3.svg";